export default __webpack_public_path__ + "static/media/target_markets_right.a96a0a56.svg";